import { toast } from "react-toastify";
import {
  plantillaProveedores,
  plantillaFincas,
  deleteFincasAAFF,
  plantillaMatcheo,
  plantillaAAFF,
  plantillaRenovaciones,
  plantillaFincasLOPD,
  plantillaFincasCae,
  plantillasProveedorCae,
  plantillaTrabajadorProveedor
} from "../services";
import Swal from "sweetalert2";
import i18n from "../i18n";
import { excelToJson } from "../providers/excel-to-json";

// Detecta si el Excel de AAFFs incluye al menos una fila con LegalIA activado
// (columna "legalia" / "legalia_id" con valor no vacío y distinto de 0/"no").
const detectarLegaliaEnExcel = (file) => new Promise((resolve) => {
  try {
    excelToJson(file, (rows) => {
      const hayLegalia = (rows || []).some((row) => {
        const raw = row.legalia_id ?? row.legalia ?? row.LegalIA ?? row.legalIA;
        if (raw === undefined || raw === null || raw === "") return false;
        const txt = String(raw).trim().toLowerCase();
        if (!txt || txt === "0" || txt === "no" || txt === "false") return false;
        return true;
      });
      resolve(hayLegalia);
    });
  } catch (e) {
    resolve(false);
  }
});

const t = (key) => i18n.t(key, { ns: 'common' });

export const subirListadoProveedores = async (evt) => {
  let toastInfo = toast.info(t('templates.messages.uploadingSuppliers'), { autoClose: false });

  const value = evt.target.files[0];
  try {
    if (value) {
      let itemsOk = []
      let itemsErr = []
      const res = await plantillaProveedores(value);


      if (res.status === 402) {
        toast.error(res.data.error);
        toast.dismiss(toastInfo);
        return;
      }
      if (res.status === 403) {
        toast.error(res.data.error[0]);
        toast.dismiss(toastInfo);
        return;
      }
      res.data.forEach(item => {
        if (item.status === 200) {
          itemsOk.push(item.msg)
          toast.dismiss(toastInfo);

          toast.success(item.msg);

        }
        else if (item.status === 400) {
          itemsErr.push(item.msg)
          toast.dismiss(toastInfo);

        }
        else {
          toast.error(t('templates.messages.errorUploadSuppliers'));
        }
      })


      const html = `
          <div style="display: flex;">
            <div style="flex: 1;">
              <ul style="font-size:13px; margin-top:10px; text-align:left;">
                ${itemsErr.map(item => `<li style="margin:5px 0;">${item}</li>`).join('')}
              </ul>
            </div>
          </div>
        `;
      if (itemsErr.length > 0) {
        Swal.fire({
          title: t('templates.messages.errorUploadingSuppliers'),
          html: html,
          confirmButtonText: t('actions.close'),
          icon: 'error'
        });
      }
    }
  } catch (error) {
    toast.update(toastInfo, {
      render: t('templates.messages.errorOccurred'),
      type: toast.TYPE.ERROR,
      autoClose: true
    });
  }

}

export const subirListadoRenovaciones = (evt) => {
  let toastInfo = toast.info(t('templates.messages.uploadingRenewals'));
  const value = evt.target.files[0];
  if (value) {
    plantillaRenovaciones(value).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        toast.update(toastInfo, {
          render: t('templates.messages.propertiesRenewedSuccess'),
          type: toast.TYPE.SUCCESS,
          autoClose: true
        });
      } else {
        toast.update(toastInfo, {
          render: t('templates.messages.errorRenewingProperties'),
          type: toast.TYPE.ERROR,
          autoClose: true
        });
      }
    })
      .catch((err) => {
        toast.update(toastInfo, {
          render: t('messages.error'),
          type: toast.TYPE.ERROR,
          autoClose: true
        });
        console.error(err);
      });
  }
}

export const subirTrabajadorProveedor = (evt) => {
  let toastInfo = toast.info(t('templates.messages.uploadingSupplierWorkers'), { autoClose: false });
  const value = evt.target.files[0];
  if (value) {
    const formData = new FormData();
    formData.append('file', value);
    //formData.append('sobreescribir', 'true');
    plantillaTrabajadorProveedor(formData).then((res) => {
      if (parseInt(res.correctos) && res.erroneos.length == 0) {
        toast.update(toastInfo, {
          render: t('templates.messages.workersProcessed'),
          type: toast.TYPE.SUCCESS,
          autoClose: true
        });
      } else if (res.erroneos.length > 0) {
        toast.update(toastInfo, {
          render: parseInt(res.correctos) > 0 ? t('templates.messages.someWorkersNotImported') : t('templates.messages.errorWorkersNotImported'),
          type: parseInt(res.correctos) > 0 ? toast.TYPE.WARNING : toast.TYPE.ERROR,
          autoClose: true
        });
        Swal.fire({
          title: t('templates.messages.errorImportingSomeWorkers'),
          html: res.erroneos.join('<br>'),
          confirmButtonText: t('actions.close'),
          icon: 'error'
        });
      }
    })
      .catch((err) => {
        toast.update(toastInfo, {
          render: t('templates.messages.errorImportingWorkers'),
          type: toast.TYPE.ERROR,
          autoClose: true
        });
        console.error(err);
      });
  }
}

export const subirListadoLOPD = async (evt) => {
  const value = evt.target.files[0];
  if (value) {
    let toastInfo = toast.info(t('templates.messages.uploadingLopdProperties'), { autoClose: false });

    try {
      let itemsOk = []
      let itemsErr = []
      const res = await plantillaFincasLOPD(value);

      if (res.status === 402) {
        toast.dismiss(toastInfo);
        mostrarRegistrosInvalidos(res);
        return;
      }
      if (res.status === 403) {
        toast.error(res.data.error[0]);
        toast.dismiss(toastInfo);
        return;
      }
      if (res.data) {
        res.data.forEach(item => {
          if (item.status === 200) {
            itemsOk.push(item.msg)
            toast.dismiss(toastInfo);
            toast.success(item.msg);
          }
          else if (item.status === 400) {
            itemsErr.push(item.msg)
            toast.dismiss(toastInfo);

          }
          else {
            toast.error(t('templates.messages.errorUploadProperties'));
          }
        })
      } else {
        console.log(res.error)
        const r = res.error || t('messages.error')
        toast.update(toastInfo, {
          render: r,
          type: toast.TYPE.ERROR,
          autoClose: true
        });
        return
      }

      const html = `
      <div style="display: flex;">
        <div style="flex: 1;">
          <ul style="font-size:13px; margin-top:10px; text-align:left;">
            ${itemsErr.map(item => `<li style="margin:5px 0;">${item}</li>`).join('')}
          </ul>
        </div>
      </div>
    `;
      if (itemsErr.length > 0) {
        Swal.fire({
          title: t('templates.messages.errorUploadLopdProperties'),
          html: html,
          confirmButtonText: t('actions.close'),
          icon: 'error'
        });
      }
    } catch (error) {
      toast.update(toastInfo, {
        render: t('messages.error'),
        type: toast.TYPE.ERROR,
        autoClose: true
      });
    }


  }
}
export const subirListadoAAFF = async (evt) => {
  const value = evt.target.files[0];
  if (value) {
    let toastInfo = toast.info(t('templates.messages.uploadingPropertyManagers'), { autoClose: false });
    const hayLegalia = await detectarLegaliaEnExcel(value);
    try {
      let itemsOk = []
      let itemsErr = []
      const res = await plantillaAAFF(value);

      //console.log(res);
      if (res.status === 402) {
        toast.error(res.data.error);
        toast.dismiss(toastInfo);
        return;
      }
      if (res.status === 403) {
        toast.error(res.data.error[0]);
        toast.dismiss(toastInfo);
        return;
      }
      if (res.data) {
        res.data.forEach(item => {
          if (item.status === 200) {
            itemsOk.push(item.msg)
            toast.dismiss(toastInfo);
            toast.success(item.msg);
          }
          else if (item.status === 400) {
            // console.log(item.msg);
            itemsErr.push(item.msg)
            toast.dismiss(toastInfo);
            // toast.error(item.msg);
          }
          else if (item.status === 402) {
            //console.log(item.msg);
            itemsErr.push(item.msg)
            toast.dismiss(toastInfo);
            // toast.error(item.msg);
          }


          else {
            toast.error(t('templates.messages.errorUploadPropertyManagers'));
          }
        })
      } else {
        //console.log(res.error)
        const r = res.error?.[0] || t('messages.error')
        toast.update(toastInfo, {
          render: r,
          type: toast.TYPE.ERROR,
          autoClose: true
        });
        return
      }

      const html = `
        <div style="display: flex;">
          <div style="flex: 1;">
            <ul style="font-size:13px; margin-top:10px; text-align:left;">
              ${itemsErr.map(item => `<li style="margin:5px 0;">${item}</li>`).join('')}
            </ul>
          </div>
        </div>
      `;
      if (itemsErr.length > 0) {
        Swal.fire({
          title: t('templates.messages.errorUploadTheseAaff'),
          html: html,
          confirmButtonText: t('actions.close'),
          icon: 'error'
        });
      }

      if (hayLegalia && itemsOk.length > 0) {
        toast.info(i18n.t('messages.legaliaNotifyTomorrow', { ns: 'aaff', defaultValue: 'Mañana el administrador recibirá por email el manual de uso de Legal IA.' }));
      }
    } catch (error) {
      // const err = error[0].length === 0 ? t('messages.error') : error.error[0]
      console.log("error", error);
      // console.log(err);
      toast.update(toastInfo, {
        render: t('messages.error'),
        type: toast.TYPE.ERROR,
        autoClose: true
      });
    }


  }
}

// Muestra en un modal el detalle de los registros rechazados por el backend al subir
// el Excel de comunidades. Cada elemento de `invalidRecords` trae { index, nif, error: [...] }.
// Si no hay detalle (p. ej. Excel vacío), cae al toast con el mensaje genérico.
const mostrarRegistrosInvalidos = (res) => {
  const invalidRecords = res?.data?.invalidRecords;
  if (!Array.isArray(invalidRecords) || invalidRecords.length === 0) {
    toast.error(res?.data?.error || t('messages.error'));
    return;
  }
  const filas = invalidRecords
    .map((registro) => {
      const errores = Array.isArray(registro.error) ? registro.error : [registro.error];
      const nif = registro.nif ? ` (${registro.nif})` : "";
      const fila = registro.index !== undefined ? `Fila ${registro.index}` : "Fila";
      return `
        <li style="margin: 8px 0; border-bottom: 1px solid #eee; padding-bottom: 5px;">
          <b>${fila}${nif}</b>: ${errores.join(" ")}
        </li>`;
    })
    .join("");
  const html = `
    <div style="display: flex; flex-direction: column; max-height: 300px; overflow-y: auto;">
      <ul style="font-size: 13px; text-align: left; padding-left: 20px;">
        ${filas}
      </ul>
    </div>`;
  Swal.fire({
    title: res?.data?.error || "Errores de validación en el Excel",
    html,
    confirmButtonText: t('actions.close'),
    icon: "error",
    width: 600,
  });
};

export const subirListado = async (evt, selectedChildAaffs = null) => {
  // toast.info("Subiendo fincas...");
  let toastInfo = toast.info(t('templates.messages.uploadingCaeProperties'), { autoClose: false });
  const value = evt.target ? evt.target.files[0] : evt;

  try {
    let itemsOk = []
    let itemsErr = []
    const res = await plantillaFincas(value, selectedChildAaffs);

    if (res.data?.requiresSelection) {
      toast.dismiss(toastInfo);
      await mostrarModalSeleccionAAFF(res.data.registrosParaSeleccion, value);
      return;
    }

    if (res.status === 402) {
      toast.dismiss(toastInfo);
      mostrarRegistrosInvalidos(res);
      return;
    }
    if (res.status === 400) {
      toast.dismiss(toastInfo);
      mostrarRegistrosInvalidos(res);
      return;
    }
    if (res.data) {
      res.data.forEach(item => {
        if (item.status === 200) {
          itemsOk.push(item.msg)
          toast.dismiss(toastInfo);
          toast.success(item.msg);
        }
        else if (item.status === 400) {
          itemsErr.push(item.msg)
          toast.dismiss(toastInfo);
          // toast.error(item.msg);
        }
        else {
          toast.error(t('templates.messages.errorUploadProperties'));
        }
      })
    } else {
      console.log(res.error)
      const r = res.error?.[0] || t('messages.error')
      toast.update(toastInfo, {
        render: r,
        type: toast.TYPE.ERROR,
        autoClose: true
      });
      return
    }


    const html = `
    <div style="display: flex;">
      <div style="flex: 1;">
        <ul style="font-size:13px; margin-top:10px; text-align:left;">
          ${itemsErr.map(item => `<li style="margin:5px 0;">${item}</li>`).join('')}
        </ul>
      </div>
    </div>
  `;
    if (itemsErr.length > 0) {
      Swal.fire({
        title: t('templates.messages.errorUploadTheseProperties'),
        html: html,
        confirmButtonText: t('actions.close'),
        icon: 'error'
      });
    }

  } catch (error) {
    toast.update(toastInfo, {
      render: t('messages.error'),
      type: toast.TYPE.ERROR,
      autoClose: true
    });
  }

}

const mostrarModalSeleccionAAFF = async (registrosParaSeleccion, file) => {
  const selectsHTML = registrosParaSeleccion.map((registro, index) => {
    const optionsHTML = registro.hijos.map(hijo =>
      `<option value="${hijo.nif}">${hijo.razonSocial}</option>`
    ).join('');

    return `
      <div style="margin-bottom: 20px; text-align: left; padding: 15px; background: #f9f9f9; border-radius: 5px;">
        <label style="display: block; font-weight: bold; margin-bottom: 8px; color: #333;">
          AAFF: ${registro.nifAAFF} - ${registro.razonSocialAAFF}
        </label>
        <p style="font-size: 12px; color: #666; margin-bottom: 8px;">
          ${t('templates.messages.selectOfficeForProperties')}
        </p>
        <select id="select-aaff-${index}" class="swal2-input" style="width: 100%; padding: 8px;">
          <option value="">${t('templates.messages.keepOriginalNif')}</option>
          ${optionsHTML}
        </select>
      </div>
    `;
  }).join('');

  const result = await Swal.fire({
    title: t('templates.messages.aaffSelection'),
    html: `
      <div style="max-height: 400px; overflow-y: auto;">
        <p style="margin-bottom: 20px; color: #666;">
          ${t('templates.messages.aaffMatrixDetected')}
        </p>
        ${selectsHTML}
      </div>
    `,
    confirmButtonText: t('actions.continue'),
    confirmButtonColor: '#92004d',
    cancelButtonText: t('actions.cancel'),
    showCancelButton: true,
    width: '600px',
    preConfirm: () => {
      const selecciones = {};

      registrosParaSeleccion.forEach((registro, index) => {
        const select = document.getElementById(`select-aaff-${index}`);
        const valorSeleccionado = select.value;

        selecciones[registro.nifAAFF] = valorSeleccionado || registro.nifAAFF;
      });

      return selecciones;
    }
  });

  if (result.isConfirmed) {
    await subirListado(file, result.value);
  }
}
export const subirListadoMatcheo = (evt) => {
  let toastId = toast.info(t('templates.messages.performingMatching'), { autoClose: false });
  const value = evt.target.files[0];
  if (value) {
    plantillaMatcheo(value)
      .then((res) => {
        if (res.status === 403) {

          const { error, detalles } = res.data;
          const html = `
            <div style="display: flex; flex-direction: column; max-height: 300px; overflow-y: auto;"> 
              <ul style="font-size: 13px; text-align: left; padding-left: 20px;">
                ${detalles.map((item) => `
                  <li style="margin: 8px 0; border-bottom: 1px solid #eee; padding-bottom: 5px;">
                    ${item}
                  </li>
                `).join('')}
              </ul>
            </div>
          `;

          Swal.fire({
            title: 'Errores de validación en el Excel',
            html: html,
            confirmButtonText: 'Cerrar',
            icon: 'error',
            width: 600
          });

        } else if (res.status === 402) {

          // Excel vacío
          Swal.fire({
            title: 'Excel vacío',
            text: res.data.error,
            icon: 'warning',
            confirmButtonText: 'Cerrar'
          });

        } else {
          // Procesar respuestas exitosas y errores de negocio
          let itemsErr = [];
          let successCount = 0;

          res.data.forEach((item) => {
            if (item.status === 200) {
              successCount++;
            }
            if (item.status === 400) {
              itemsErr.push(item.msg);
            }
          });

          if (successCount > 0) {
            toast.success(`${successCount} registros procesados correctamente`);
          }

          if (itemsErr.length > 0) {
            const html = `
              <div style="display: flex; flex-direction: column; max-height: 300px; overflow-y: auto;">
                <ul style="font-size: 13px; text-align: left;">
                  ${itemsErr.map((item) => `<li style="margin: 5px 0;">${item}</li>`).join('')}
                </ul>
              </div>
            `;

            Swal.fire({
              title: 'Errores al crear el match',
              html: html,
              confirmButtonText: 'Cerrar',
              icon: 'error'
            });
          }
        }
        toast.dismiss(toastId);
      })
      .catch((err) => {
        toast.dismiss(toastId);
        toast.error("Ha ocurrido un error");
        console.error(err);
      }).finally(() => {
        evt.target.value = ''; 
      });
  } else {
    toast.dismiss(toastId);
  }
 
};
// 

export const eliminarFincas = (aaff) => {
  return new Promise(async (resolve, reject) => {
    try {
      Swal.fire({
        title: t('templates.messages.deleteAllPropertiesOfAaff') + " " + aaff.razonSocial + "?",
        showCancelButton: true,
        confirmButtonText: t('actions.delete'),
      }).then((result) => {

        if (result.isConfirmed) {
          deleteFincasAAFF(aaff.nif)
            .then((res) => {
              if (res.message === "PROPERTIE_DELETED") {
                toast.success(t('templates.messages.propertiesDeleted'));
                resolve(true);
              } else {
                toast.error(t('templates.messages.errorDeletingAllProperties'));
              }
            })
            .catch((error) => {
              console.log(error);
              toast.error(t('templates.messages.errorDeletingAllProperties'));
              reject(error)
            });
        }
      });
    } catch (error) {
      console.log(error)
      toast.error(t('messages.error'));
      reject(error)
    }
  })
}

export const subirProveedorCae = async (ev) => {
  const value = ev.target.files[0];
  if (!value) {
    return;
  }

  let toastInfo = toast.info(t('templates.messages.uploadingCaeProperties'), {autoClose: false});

  try {
    let itemsOk = []
    let itemsErr = []
    const res = await plantillasProveedorCae(value);
    toast.dismiss(toastInfo);
    console.log(res);
    if (res.status === 402) {
      toast.error(res.data.error);
      return;
    }
    if (res.status === 403) {
      toast.error(res.data.error[0]);
      return;
    }
    if (res.data) {
      res.data.forEach(item => {
        if (item.status === 'success') {
          itemsOk.push(item.message)
        }
        else if (item.status === 'error') {
          itemsErr.push(item.message);
        }
        else {
          toast.error(t('templates.messages.errorUploadSuppliers'));
        }
      })
    } else {
      console.log(res.error)
      const r = res.error?.[0] || t('messages.error')
      toast.update(toastInfo, {
        render: r,
        type: toast.TYPE.ERROR,
        autoClose: true
      });
      return;
    }

    const html = `
      <div style="display: flex;">
        <div style="flex: 1;">
          <ul style="font-size:13px; margin-top:10px; text-align:left;">
            ${itemsErr.map(item => `<li style="margin:5px 0;">${item}</li>`).join('')}
          </ul>
        </div>
      </div>
    `;
    if (itemsErr.length > 0) {
      Swal.fire({
        title: t('templates.messages.errorUploadCaeSupplier'),
        html: html,
        confirmButtonText: t('actions.close'),
        icon: 'error'
      });
    }
  } catch (error) {
    toast.update(toastInfo, {
      render: t('messages.error'),
      type: toast.TYPE.ERROR,
      autoClose: true
    });
  }
}

export const subirComunidadCae = async (ev) => {
  const value = ev.target.files[0];
  if (!value) {
    return;
  }
  let toastInfo = toast.info(t('templates.messages.uploadingCaeProperties'), { autoClose: false });

  try {
    let itemsOk = []
    let itemsErr = []
    const res = await plantillaFincasCae(value);
    console.log(res);
    if (res.status === 402) {
      toast.dismiss(toastInfo);
      mostrarRegistrosInvalidos(res);
      return;
    }
    if (res.status === 403) {
      toast.error(res.data.error[0]);
      toast.dismiss(toastInfo);
      return;
    }
    if (res.data) {
      res.data.forEach(item => {
        if (item.status === 'success') {
          itemsOk.push(item.message)
          toast.dismiss(toastInfo);
          toast.success(item.message);
        }
        else if (item.status === 'error') {
          itemsErr.push(item.message);
          toast.dismiss(toastInfo);
        }
        else {
          toast.error(t('templates.messages.errorUploadProperties'));
        }
      })
    } else {
      console.log(res.error)
      const r = res.error || t('messages.error')
      toast.update(toastInfo, {
        render: r,
        type: toast.TYPE.ERROR,
        autoClose: true
      });
      return;
    }

    const html = `
      <div style="display: flex;">
        <div style="flex: 1;">
          <ul style="font-size:13px; margin-top:10px; text-align:left;">
            ${itemsErr.map(item => `<li style="margin:5px 0;">${item}</li>`).join('')}
          </ul>
        </div>
      </div>
    `;
    if (itemsErr.length > 0) {
      Swal.fire({
        title: t('templates.messages.errorUploadCaeProperties'),
        html: html,
        confirmButtonText: t('actions.close'),
        icon: 'error'
      });
    }
  } catch (error) {
    toast.update(toastInfo, {
      render: t('messages.error'),
      type: toast.TYPE.ERROR,
      autoClose: true
    });
  }
}